const doLoad = Symbol();

function transferKeyDone(key) {
  return 'transferKey' + key + ':DONE';
}

class Storage {
  constructor() {
    // transfers sessionStorage from this tab to another
    const storageListener = function(event) {
      if (!event) {
        event = window.event;
      }
      const value = event.newValue;
      if (!value) {
        return; // do nothing if no value to work with
      }

      const matched = event.key.match(/requestKey(.+)/);
      if (matched) {
        const key = matched[1];
        //someone requested a value
        const stored = sessionStorage.getItem(key);
        if (stored) {
          const eventLoadedKey = transferKeyDone(key);

          //emit event, then clean
          localStorage.setItem(eventLoadedKey, stored);
          localStorage.removeItem(eventLoadedKey);
        }
      }
    };

    // listen for changes to localStorage
    if (window.addEventListener) {
      window.addEventListener('storage', storageListener, false);
    } else {
      window.attachEvent('onstorage', storageListener);
    }
  }

  [doLoad](key) {
    const eventKey = 'requestKey' + key;
    const eventLoadedKey = transferKeyDone(key);

    const me = this;

    return new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => {
        reject();
      }, 100);
      // recover data from another tab
      const storageTransfer = function(event) {
        if (!event) {
          event = window.event;
        }

        const value = event.newValue;
        if (!value) {
          return; // do nothing if no value to work with
        }

        if (event.key == eventLoadedKey) {
          if (window.addEventListener) {
            window.removeEventListener('storage', storageTransfer);
          } else {
            window.removeEventListener('onstorage', storageTransfer);
          }

          //the response is transfered and there is no key
          if (!sessionStorage.getItem(key)) {
            me.setItem(key, value);
            clearTimeout(timeout);
            resolve(JSON.parse(value));
          }
        }
      };

      // listen for changes to localStorage
      if (window.addEventListener) {
        window.addEventListener('storage', storageTransfer, false);
      } else {
        window.attachEvent('onstorage', storageTransfer);
      }
      localStorage.setItem(eventKey, key);
      localStorage.removeItem(eventKey);
    });
  }

  loadKey(key) {
    var promises = [];
    key.forEach(element => {
      const initialValue = this.getItem(element);
      if (initialValue != null) {
        promises.push(Promise.resolve(initialValue));
      } else {
        promises.push(this[doLoad](element));
      }
    });
    return Promise.all(promises);
  }

  getItem(key) {
    const item = sessionStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return item;
  }

  removeItem(key) {
    sessionStorage.removeItem(key);
  }

  setItem(key, value) {
    sessionStorage.setItem(key, value);
  }
}

export default new Storage();
